export const BILL_OCR_ENDPOINTS = {
  EXTRACT: "/bill-ocr/extract",
  SEND_TO_NXMAP: "/bill-ocr/send-to-nxmap",
};
